<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="analyzer.id !== undefined"
          label="ID"
          v-model="analyzer.id"
          disabled
        >
        </v-text-field>

        <v-text-field
          label="Nume"
          v-model="analyzer.name"
          :rules="requiredRule"
          required
        >
        </v-text-field>

        <v-text-field
          label="Serie"
          v-model="analyzer.series"
          :rules="requiredRule"
          required
        >
        </v-text-field>

           <v-menu
          ref="menuDate"
          v-model="menuDate"
          :close-on-content-click="false"
          :return-value.sync="analyzer.expireAt"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="analyzer.expireAt"
              label="Data expirare"
              prepend-icon="event"
              readonly
              v-on="on"
              :rules="requiredRule"
            ></v-text-field>
          </template>
          <v-date-picker v-model="analyzer.expireAt" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menuDate.save(analyzer.expireAt)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['analyzer', 'onSubmit'],
  name: 'AnalyzerForm',
  data() {
    return {
      valid: true,
      menuDate: false,
      requiredRule: [(v) => !!v || 'Campul trebuie completat.'],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
